import React from "react";
import { API, graphqlOperation } from "aws-amplify";

const defaultData = [
  "High Debt/EV",
  "Low Debt/EV",
  "High Short Interest",
  "Low Short Interest",
  "High Beta",
  "Low Beta",
  "High Yield",
  "Low Yield",
  "MCAP Bottom 25%",
  "MCAP Top 25%",
  "Top 25% Sales Growth",
  "Bottom 25% Sales Growth",
  "Top 25% EPS Growth",
  "Bottom 25 % EPS Growth",
].map((obj) => {
  return {
    name: obj,
    day: 0,
    week: 0,
    month: 0,
    three_month: 0,
    six_month: 0,
    ytd: 0,
  };
});
export default function StyleSectorPerformance(props) {
  const newDataMap = {
    Volatility: "VOL_CALC_QUINTILE_DF",
    Beta: "BETA_CALC_QUINTILE_DF",
    "Div Yld": "DIV_YLD_CALC_QUINTILE_DF",
    Growth1: "PAST_GRWTH_CALC_QUINTILE_DF",
    Growth2: "FUT_GRWTH_CALC_QUINTILE_DF",
    Sentiment: "EXPECT_CALC_QUINTILE_DF",
    "Short Int": "SHORT_INT_CALC_QUINTILE_DF",
    "Mkt Cap": "MKT_CAP_CALC_QUINTILE_DF",
    Technicals: "RSI_CALC_QUINTILE_DF",
    Leverage: "LEVERAGE_CALC_QUINTILE_DF",
    Momo: "MOMO_CALC_QUINTILE_DF",
    Profits: "PROFIT_CALC_QUINTILE_DF",
    Value: "VALUE_CALC_QUINTILE_DF",
  };
  const [data, setData] = React.useState(defaultData);
  const [newData, setNewData] = React.useState([]);

  React.useEffect(() => {
    refresh();
  }, []);

  React.useEffect(() => {
    if (props.reload) {
      setData(defaultData);
      refresh();
    }
  }, [props.reload]);

  const refresh = async () => {
    const data = (
      await API.graphql(
        graphqlOperation(`{
        style_sector(order_by: {order: asc}) {
          section
          name
          day
          week
          month
          three_month
          six_month
          ytd
        }
      }`),
      )
    ).data;
    const data2 = await API.graphql(
      graphqlOperation(`{
        python_scripts_cache_by_pk(id: "styleFactors") {
          data
        }
      }`),
    );

    //there are two growth sector with the same name (Growth). this loop goes and distinguishes
    //the two names and changes it to Growth1 and Growth2.
    let growthNameCount = 1;
    const styleSectorData = data.style_sector.map((obj) => {
      if (obj.section === "Growth") {
        obj.section = obj.section + Math.ceil(growthNameCount / 2);
        growthNameCount++;
      }
      return obj;
    });

    setNewData(data2.data.python_scripts_cache_by_pk.data);
    setData(styleSectorData);
  };
  function greaterThanZero(num) {
    return num === 0 ? "white" : num > 0 ? "green" : "red";
  }

  const tableData = data.map((row, i) => {
    let growth = 0;
    if (row.section === "Growth") growth++;
    return (
      <div className="asset-info-row" key={i}>
        <div
          className={`cell-info`}
          style={{
            position: "relative",
            top: -10,
            left: 12,
            display: "inline",
          }}
        >
          {" "}
          {/* change Growth1 and Growth2 name to just Growth */}
          {i % 2
            ? row.section?.includes("Growth")
              ? "Growth"
              : row.section
            : ""}
        </div>
        <div className={`cell-info`}></div>
        <div className={`cell-index`} style={{ padding: 6 }}>
          <div>{row.name}</div>
        </div>
        <div
          className={`cell-info ${greaterThanZero(
            row.day &&
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_D_PERCENT"][i % 2 === 0 ? 1 : 5],
          )}`}
        >
          {row.day &&
            (
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_D_PERCENT"][i % 2 === 0 ? 1 : 5] * 100
            ).toFixed(2) + "%"}
        </div>
        <div
          className={`cell-info ${greaterThanZero(
            row.week &&
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_W_PERCENT"][i % 2 === 0 ? 1 : 5],
          )}`}
        >
          {row.week &&
            (
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_W_PERCENT"][i % 2 === 0 ? 1 : 5] * 100
            ).toFixed(2) + "%"}
        </div>
        <div
          className={`cell-info ${greaterThanZero(
            row.month &&
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_M_PERCENT"][i % 2 === 0 ? 1 : 5],
          )}`}
        >
          {row.month &&
            (
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_M_PERCENT"][i % 2 === 0 ? 1 : 5] * 100
            ).toFixed(2) + "%"}
        </div>
        <div
          className={`cell-info ${greaterThanZero(
            row.three_month &&
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["THREE_M_PERCENT"][i % 2 === 0 ? 1 : 5],
          )}`}
        >
          {row.three_month &&
            (
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["THREE_M_PERCENT"][i % 2 === 0 ? 1 : 5] * 100
            ).toFixed(2) + "%"}
        </div>
        <div
          className={`cell-info ${greaterThanZero(
            row.six_month &&
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["SIX_M_PERCENT"][i % 2 === 0 ? 1 : 5],
          )}`}
        >
          {row.six_month &&
            (
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["SIX_M_PERCENT"][i % 2 === 0 ? 1 : 5] * 100
            ).toFixed(2) + "%"}
        </div>
        <div
          className={`cell-info ${greaterThanZero(
            row.ytd &&
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_Y_PERCENT"][i % 2 === 0 ? 1 : 5],
          )}`}
        >
          {row.ytd &&
            (
              newData[
                newDataMap[
                  row.section === "Growth"
                    ? growth < 3
                      ? "Growth1"
                      : "Growth2"
                    : row.section
                ]
              ]["ONE_Y_PERCENT"][i % 2 === 0 ? 1 : 5] * 100
            ).toFixed(2) + "%"}{" "}
        </div>
      </div>
    );
  });

  return (
    <section className="section style-sector-performance">
      <div className="section-title">Style Factor Performance</div>

      <div className="sub-header-style-sector">
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div className="transparent">.</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>Style</div>
        </div>
        <div className="sub-header-text">
          <div className="transparent">.</div>
          <div>Factor</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">1D</div>
          <div className="sub-header-line"></div>
          <div className="justify-center">% Chg</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">1W</div>
          <div className="sub-header-line"></div>
          <div className="justify-center">% Chg</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">1M</div>
          <div className="sub-header-line"></div>
          <div className="justify-center">% Chg</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">3M</div>
          <div className="sub-header-line"></div>
          <div className="justify-center">% Chg</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">6M</div>
          <div className="sub-header-line"></div>
          <div className="justify-center">% Chg</div>
        </div>
        <div className="sub-header-text">
          <div className="justify-center">YTD</div>
          <div className="sub-header-line"></div>
          <div className="justify-center">%</div>
        </div>
      </div>
      <div className="style-sector-performance-content">{tableData}</div>
    </section>
  );
}
